import request from '@/utils/request.js';
import Qs from 'qs';

/**
 * 检查考聘服务
 */
export class CheckAndReviewBaseSvr {
  constructor() {
    this.baseurl = 'CheckAndReviewBaseSvr.assx/';
    this.publishurl ='CheckAndReviewControllerSvr.assx/';
  }

  /**
   * 发起检查考评
   * token:String, name:String, resume:String, startTime:Date, endTime:Date, templateId:String, cantons:String
   */
  CreateCheckAndReview(token, name, resume, startTime, endTime, templateId, cantons) {
    return request.post(this.baseurl + 'CreateCheckAndReview', Qs.stringify({ token: token, name: name, resume: resume, startTime: startTime, endTime: endTime, templateId: templateId, cantons: cantons }));
  }

  /**
   * 获取物业区域检查考评结果详情
   * token:String, checkAndReviewId:String, eaAreaCode:String
   */
  GetCheckAndReviewResult(token, checkAndReviewId, eaAreaCode) {
    return request.post(this.baseurl + 'GetCheckAndReviewResult', Qs.stringify({ token: token, checkAndReviewId: checkAndReviewId, eaAreaCode: eaAreaCode }));
  }

  /**
   * 删除检查考评
   * token:String, checkAndReviewId:String
   */
  DeleteCheckAndReview(token, checkAndReviewId) {
    return request.post(this.baseurl + 'DeleteCheckAndReview', Qs.stringify({ token: token, checkAndReviewId: checkAndReviewId }));
  }

  /**
   * 提交检查考评结果
   * token:String, checkAndReviewId:String, eaAreaCode:String, resultList:CheckAndReviewResultList
   */
  SubmitCheckAndReviewResult(token, checkAndReviewId, eaAreaCode, resultList) {
    return request.post(this.baseurl + 'SubmitCheckAndReviewResult', Qs.stringify({ token: token, checkAndReviewId: checkAndReviewId, eaAreaCode: eaAreaCode, resultList: typeof resultList === 'undefined' || resultList === null ? '' : resultList.toString() }));
  }

  /**
   * 发布检查考评公告
   * token:String
   */
  PublishCheckAndReviewNotice(token,checkAndReviewId) {
    return request.post(this.baseurl + 'PublishCheckAndReviewNotice', Qs.stringify({ token: token ,checkAndReviewId:checkAndReviewId}));
  }

  /**
   * 获取检查考评列表
   * token:String, keyWords:String, startIndex:int, maxSize:int, returnToTotalCount:boolean
   */
  GetCheckAndReviewList(token, keyWords, startIndex, maxSize, returnToTotalCount) {
    return request.post(this.baseurl + 'GetCheckAndReviewList', Qs.stringify({ token: token, keyWords: keyWords, startIndex: startIndex, maxSize: maxSize, returnToTotalCount: returnToTotalCount }));
  }

  /**
   * 获取检查考评详情
   * token:String, checkAndReviewId:String, option:int
   */
  GetCheckAndReviewDetail(token, checkAndReviewId, option) {
    return request.post(this.baseurl + 'GetCheckAndReviewDetail', Qs.stringify({ token: token, checkAndReviewId: checkAndReviewId, option: option }));
  }

  /**
   * 获取检查考评物业区域列表
   * token:String, checkAndReviewId:String, keyWords:String, option:String, startIndex:int, maxSize:int, returnToTotalCount:boolean
   */
  GetCheckAndReviewEaAreaList(token, checkAndReviewId, keyWords, option, startIndex, maxSize, returnToTotalCount) {
    return request.post(this.baseurl + 'GetCheckAndReviewEaAreaList', Qs.stringify({ token: token, checkAndReviewId: checkAndReviewId, keyWords: keyWords, option: option, startIndex: startIndex, maxSize: maxSize, returnToTotalCount: returnToTotalCount }));
  }

  /**
   * 复核检查考评
   * 
   */
  Verify() {
    return request.post(this.baseurl + 'Verify', Qs.stringify({}));
  }

  /**
   * 修改检查考评
   * token:String, checkAndReview:CheckAndReviewMain
   */
  ModifyCheckAndReview(token, checkAndReview) {
    return request.post(this.baseurl + 'ModifyCheckAndReview', Qs.stringify({ token: token, checkAndReview: typeof checkAndReview === 'undefined' || checkAndReview === null ? '' : checkAndReview.toString() }));
  }

  /**
   * 统计检查考评结果
   * token:String, checkAndReviewId:String
   */
  StatisticalAnalysis(token, checkAndReviewId) {
    return request.post(this.baseurl + 'StatisticalAnalysis', Qs.stringify({ token: token, checkAndReviewId: checkAndReviewId }));
  }
}